export const Logo = () => {
  return (
    <div className="flex items-center space-x-4">
      <img 
        src="./logo.png"
        alt="Wonderland Australia"
        className="h-8 md:-ml-[50px]"
      />
      <span className="text-xl md:text-3xl font-bold text-[#dba634]">Wonderland Australia</span>
    </div>
  );
};